<div mat-dialog-content>
    <h3>Link Message to Client</h3>
    <p>Connect this message to one of your clients in the RF Platform.</p>
    <div>
        <lus-client-search label="Client"
            [SelectedAgent]="selectedAgentId" 
            [SelectedCompany]="selectedAgentCompanyId"
            [SelectedOrganization]="selectedAgentOrganizationId"
            (OnClientDTOSelected)="selectClient($event)"></lus-client-search>
    </div>
    <div class="row">
        <div class="col-12" align="end">
            <button mat-button class="btn btn-primary float-end" (click)="onSubmit()" [disabled]="!selectedClient"> Link Message </button>
            <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end" style="margin-right:10px;"> Cancel </button>
        </div>
    </div>
</div>  
